/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { GeneralSchema } from '@ashleynexvelsolutions/general-schema'
import { PageSpecificSchema } from '@ashleynexvelsolutions/page-specific-schema'
import { Seo } from '@ashleynexvelsolutions/seo'
import { graphql } from 'gatsby'
import { jsx } from 'theme-ui'
import { Container, Heading, Html } from '../components/elements'
import Layout from '../components/layout'
import { SeoFunction, GeneralSchemaFunction, PageSpecificSchemaFunction } from '../DataImports'

const Post = ({ data }) => {
  return (
    <section>
      <GeneralSchema {...GeneralSchemaFunction()} />
      <PageSpecificSchema {...PageSpecificSchemaFunction(data)} />

      <Seo {...SeoFunction(data)} />
      <Layout>
        {/* <SEO postNode={post} postSEO /> */}
        <Container sx={{ px: 2, py: [2, 3], maxWidth: 900 }}>
          <Heading sx={{ fontSize: [5, 5, 6, 7] }}>{data.wpPost.title}</Heading>
          <Html html={data.wpPost.content} />
        </Container>
      </Layout>
    </section>
  )
}

export default Post

export const pageQuery = graphql`
  query GET_POST($id: String!) {
    wpPost(id: { eq: $id }) {
      title
      content
      uri
      excerpt
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphUrl
        opengraphSiteName
        opengraphType
        opengraphImage {
          localFile {
            publicURL
          }
        }
        canonical
        twitterTitle
        twitterDescription
        twitterImage {
          sourceUrl
        }
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              fluid(fit: COVER, maxWidth: 800) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
      author {
        node {
          firstName
          lastName
        }
      }
      nexvelschemapagesposts {
        videos {
          title
          url
          description
          thumbnailImage {
            sourceUrl
            localFile {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
          uploadDate
        }
        questionsAndAnswers {
          question
          answer
        }
        maps {
          mapUrl
        }
        digitaldocuments {
          title
        }
        images {
          image {
            sourceUrl
            date
            description
            title
            localFile {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
        }
        areaServedLandingPageSchema
        serviceSchema {
          serviceNameSchema
          linkToRelevantServicePageSchema
        }
        keywordsSchema {
          keywordSchema
        }
        localAwardsSchema {
          localAwardSchema
        }
        latitudeSchema
        longitudeSchema
        relevantExternalPagesSchema {
          relevantExternalPageSchema
        }
      }
      tags {
        nodes {
          name
        }
      }
      categories {
        nodes {
          name
        }
      }
      date
      modified
    }
    wp {
      nexvelSchemaMarkup {
        nexvelschema {
          cities {
            city
          }
          services {
            service
            linkToRelevantPageOnYourWebsite
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
